'use strict';

window.API_HOST_KEY = 'apiHostUrl';

angular.module('webAgro1App').factory('ApiGlobalService',
  // eslint-disable-next-line max-lines-per-function, max-params
  function($q, $http, $rootScope, CommonHTTPService, StorageService) {
    const API_GLOBAL = 'https://api.aqila.com.br/';

    const getToken = function() {
      const deferred = $q.defer();

      $http.get(`${SERVER}global/token`).then(function(result) {
        deferred.resolve(result.data);
      }, deferred.reject);

      return deferred.promise;
    };

    return {
      getConfiguration: function() {
        if ($rootScope.isDevelopment) {
          return $q.when(Promise.resolve(`http://${window.location.hostname}:3000/`));
        }

        const params = {
          q: window.location.hostname
        };

        return $q((resolve, reject) => {
          $http.get(`${API_GLOBAL}url`, { params }).then((result) => {
            const url = result.data;
            StorageService.set(API_HOST_KEY, url);
            resolve(url);
          })
            .catch((error) => {
              // Quando retornar not found deve ocorrer error e não usar o falback
              // Esse retorno ocorre quando o cliente está desativado por exemplo
              if (!CommonHTTPService.isNotFound(error.status)) {
                const savedUrl = StorageService.get(API_HOST_KEY);
                if (savedUrl) {
                  return resolve(savedUrl);
                }
              }
              reject(error);
            });
        });
      },

      list: function() {
        const deferred = $q.defer();

        getToken().then(function(token) {
          $http({
            method: 'GET',
            url: `${API_GLOBAL}customers.json`,
            headers: {
              authorization: `Token ${token}`
            }
          }).then(function(result) {
            deferred.resolve(result.data);
          }, deferred.reject);
        }, deferred.reject);

        return deferred.promise;
      },

      listActive: function() {
        return this.list().then(function(result) {
          return $q.resolve(result.filter(function(item) {
            return item.active;
          }));
        });
      },

      getRenewalManager: function() {
        const deferred = $q.defer();

        $http({
          method: 'GET',
          url: `${SERVER}global/customer`
        }).then(function(result) {
          deferred.resolve(result.data);
        }, deferred.reject);

        return deferred.promise;
      }
    };
  });
